import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_router_view = _resolveComponent("router-view");
  return $data.isRouterAlive ? (_openBlock(), _createBlock(_component_router_view, {
    key: 0
  })) : _createCommentVNode("", true);
}